import React from "react";
import { useNavigate } from "react-router-dom";
import "./ProductCard.css";

function ProductCard({ img, name, productId, title, catId,link }) {

console.log("lahdvbkhbvf",catId); 
console.log("lahdvbkhbvf",title); 
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/Product/${link}/${productId}`, { state: { title: title, catId: catId,} });
  };

  return (
    <button onClick={handleClick} style={{ border: "none", background: "none" }}>
    <div className="pdtCrd" >
      <div className="pdCmaxW">
        <div className="pdtCmn">
          <div className="pdtCard">
            <div className="imgWraps">
              <img src={img} alt="product-img" />
            </div>
            <div>
              <p>{name}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    </button>
  );
}

export default ProductCard;
